import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider } from './context/ThemeContext';
import AudienceView from './pages/AudienceView';
import Dashboard from './pages/Dashboard';
import RequestsDashboard from './pages/RequestsDashboard';
import SongManagement from './pages/SongManagement';
import Analytics from './pages/Analytics';
import GigManagement from './pages/GigManagement';
import SetListBuilder from './pages/SetListBuilder';
import BrandingSettings from './pages/BrandingSettings';
import GigPrintSheet from './pages/GigPrintSheet';
import BandAbout from './pages/BandAbout';
import Home from './pages/Home';
import BandView from './pages/BandView';
import MusicianLayout from './components/MusicianLayout';

function App() {
  return (
    <ThemeProvider>
    <Router>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#333',
            color: '#fff',
            padding: '16px',
            borderRadius: '8px',
          },
          success: {
            iconTheme: {
              primary: '#28a745',
              secondary: '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#dc3545',
              secondary: '#fff',
            },
          },
        }}
      />
      <Routes>
        <Route path="/gig/:bandSlug/about" element={<BandAbout />} />
        <Route path="/gig/:bandSlug" element={<AudienceView />} />
        <Route path="/dashboard" element={<MusicianLayout title="Home"><Dashboard /></MusicianLayout>} />
        <Route path="/dashboard/requests" element={<MusicianLayout title="Live Requests" scrollable={false}><RequestsDashboard /></MusicianLayout>} />
        <Route path="/dashboard/songs" element={<MusicianLayout title="Songs" scrollable={false}><SongManagement /></MusicianLayout>} />
        <Route path="/dashboard/analytics" element={<MusicianLayout title="Analytics"><Analytics /></MusicianLayout>} />
        <Route path="/dashboard/gigs" element={<MusicianLayout title="Gigs"><GigManagement /></MusicianLayout>} />
        <Route path="/dashboard/gigs/:gigId/setlist" element={<MusicianLayout scrollable={false}><SetListBuilder /></MusicianLayout>} />
        <Route path="/dashboard/branding" element={<MusicianLayout title="Branding & Settings"><BrandingSettings /></MusicianLayout>} />
        <Route path="/print/gig/:gigUrl" element={<GigPrintSheet />} />
        <Route path="/band" element={<BandView />} />
        <Route path="/" element={<Home />} />
      </Routes>
    </Router>
    </ThemeProvider>
  );
}

export default App;
